export default __webpack_public_path__ + "static/media/godaddy.0c67a61e.svg";